/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Not_RestorableInputs */

const en_us2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not put that exercise back in the draft. Nothing was changed.`)
};

const pt_br2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos devolver esse exercício ao rascunho. Nada foi alterado.`)
};

const es_419_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos devolver ese ejercicio al borrador. No se cambió nada.`)
};

const pt_pt2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos devolver esse exercício ao rascunho. Nada foi alterado.`)
};

const fr_fr2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de remettre cet exercice dans le brouillon. Rien n'a été modifié.`)
};

const de_de2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir konnten diese Übung nicht in den Entwurf zurücklegen. Nichts wurde geändert.`)
};

const it_it2_plan_change_not_restorable = /** @type {(inputs: Plan_Change_Not_RestorableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a rimettere quell'esercizio nella bozza. Non è cambiato nulla.`)
};

/**
* | output |
* | --- |
* | "We could not put that exercise back in the draft. Nothing was changed." |
*
* @param {Plan_Change_Not_RestorableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_change_not_restorable = /** @type {((inputs?: Plan_Change_Not_RestorableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Not_RestorableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_change_not_restorable(inputs)
	if (locale === "es-419") return es_419_plan_change_not_restorable(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_change_not_restorable(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_change_not_restorable(inputs)
	if (locale === "de-DE") return de_de2_plan_change_not_restorable(inputs)
	if (locale === "it-IT") return it_it2_plan_change_not_restorable(inputs)
	return en_us2_plan_change_not_restorable(inputs)
});
export { plan_change_not_restorable as "plan.change_not_restorable" }